// -------------------------------------------------------------------------------
export const AKIT_CREATE_SESSION_ENDPOINT = '/algebrakit-secure/session/create';
export const AKIT_SESSION_SCORE_ENDPOINT = '/algebrakit-secure/session/score';
export const GET_SESSION_ENDPOINT = '/algebrakit-secure/session/get';
export const GET_EXERCISE_DATA_ENDPOINT = '/algebrakit-secure/exercise/published-info';
export const GET_EXERCISE_ENDPOINT =  '/algebrakit-secure/exercise/get';
export const AKIT_LOCK_SESSION_ENDPOINT = '/algebrakit-secure/sessions/lock'
export const AKIT_VALIDATE_SESSION_ENDPOINT = '/algebrakit-secure/exercise/validate';